import env from '../env.json';

type EnvFlags = Record<'LOCAL' | 'DEV' | 'TEST' | 'PROD', boolean>;

export interface Env extends EnvFlags {
    VITE_AZURE_REDIRECT_URI: string;
    VITE_API_BASE?: string;
    VITE_MOCK_SERVER?: string;
    VITE_API_USE_PROXY?: string;
    VITE_AUTH_ENTRA_AZURE_TENANT_ID?: string;
    VITE_AUTH_ENTRA_AZURE_CLIENT_ID?: string;
    VITE_AUTH_ENTRA_AUTHORITY_SCOPE?: string;
    VITE_AUTH_ENTRA_AUTHORITY_DOMAIN?: string;
    VITE_SENTRY_DSN?: string;
    VITE_ENABLE_E2E_TEST?: string;
}

/** Retrieves the current environment configuration with additional computed properties.
 *
 * @function
 * @returns A modified environment configuration object with added properties:
 * - DEV: A boolean indicating if the environment is in development mode (host starts with "localhost").
 * - TEST: A boolean indicating if the environment is in test mode (host starts with "kundenportal-webclient.public.aks.test.bundo.eu").
 * - PROD: A boolean indicating if the environment is in production mode (host starts with "kundenportal-webclient.public.aks.prod.bundo.eu").
 */
export const getEnv = (): Env => {
    const host = globalThis.window?.location?.host;
    const LOCAL = host?.startsWith('localhost');
    const DEV = LOCAL || host?.includes('dev');
    const TEST = host?.includes('test');
    const PROD = !LOCAL && !DEV && !TEST;
    const fallback = env.VITE_API_BASE;
    const envFlags: EnvFlags = {
        LOCAL,
        DEV,
        TEST,
        PROD,
    };

    return {
        ...env,
        VITE_API_BASE: import.meta.env.VITE_API_BASE || fallback,
        ...envFlags,
    };
};

export const getEnvDescription = () => {
    const environment = getEnv();
    if (environment.LOCAL) {
        return 'local';
    } else if (environment.DEV) {
        return 'development';
    } else if (environment.TEST) {
        return 'test';
    } else {
        return 'production';
    }
};
